import { ICellRendererParams } from '@ag-grid-enterprise/all-modules';
import { Box, makeStyles, Tooltip } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';

import { FontSizes } from '../../../../core/config/mainTheme';

interface Props extends ICellRendererParams {
  icon?: React.ReactNode;
  valueIfEmpty?: any;
  onClickHandler?: (...args: any[]) => void;
  toolTipText?: string;
}

const ClickableCellRenderer: React.FC<Props> = (props) => {
  const classes = useStyles();
  const onCellClicked = () =>
    props.onClickHandler !== undefined ? props.onClickHandler(props.data) : {};

  return (
    <Box onClick={onCellClicked} className={classNames([classes.link, props.icon && classes.icon])}>
      {props.icon ? (
        <Tooltip title={props.toolTipText || ''} arrow>
          {props.icon as React.ReactElement}
        </Tooltip>
      ) : (
        props.value || props.valueIfEmpty
      )}
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  link: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textDecoration: 'none',
    color: theme.palette.primary.main,
    fontWeight: FontSizes.fontWeight.bold,
    cursor: 'pointer',
    marginLeft: -1 * (theme.spacing(6) + 1),
    marginRight: -1 * (theme.spacing(6) + 1),
    paddingLeft: theme.spacing(6),
  },
  icon: {
    paddingTop: theme.spacing(4),
  },
}));

export default ClickableCellRenderer;
